import { useEffect, useState } from "react";
import { getNextDrop } from "../data/drops";

const pad = (n) => String(n).padStart(2, "0");

const getParts = (drop) => {
  const diff = Math.max(0, new Date(drop.dateISO).getTime() - Date.now());
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff % 86400000) / 3600000),
    mins: Math.floor((diff % 3600000) / 60000),
    secs: Math.floor((diff % 60000) / 1000),
  };
};

export const DropCountdown = ({ dark = true }) => {
  const drop = getNextDrop();
  const [t, setT] = useState(() => (drop ? getParts(drop) : null));

  useEffect(() => {
    if (!drop) return undefined;
    const id = setInterval(() => setT(getParts(drop)), 1000);
    return () => clearInterval(id);
  }, [drop]);

  if (!drop || !t) {
    return (
      <p data-testid="drop-countdown" className={`font-serif text-2xl italic ${dark ? "text-turmeric" : "text-beet"}`}>
        New drops are announced to the waitlist first.
      </p>
    );
  }

  const cells = [
    { v: t.days, l: "Days" },
    { v: t.hours, l: "Hours" },
    { v: t.mins, l: "Mins" },
    { v: t.secs, l: "Secs" },
  ];

  return (
    <div data-testid="drop-countdown" className="flex gap-3 md:gap-4" role="timer" aria-label={`Countdown to ${drop.name}`}>
      {cells.map((c) => (
        <div
          key={c.l}
          className={`flex-1 rounded-2xl border px-2 py-4 text-center ${
            dark ? "bg-white/[0.07] border-white/15" : "bg-paper-card border-[#E7E2D7]"
          }`}
        >
          <p className={`font-mono text-3xl md:text-4xl font-semibold tabular-nums ${dark ? "text-turmeric" : "text-beet"}`}>
            {pad(c.v)}
          </p>
          <p className={`font-mono text-[10px] tracking-[0.2em] uppercase mt-1 ${dark ? "text-white/50" : "text-ink-muted"}`}>
            {c.l}
          </p>
        </div>
      ))}
    </div>
  );
};
